import {
  PRODUCT_JUKE,
  PRODUCT_LIVE,
  PRODUCT_WATER_MIRROR,
  PRODUCT_REGISTRATION_ACTIVITY,
  PRODUCT_WECHAT_WEAPP,
  PRODUCT_WEDDING_HALL,
  PRODUCT_INVITATION_CARD,
  PRODUCT_COUPONS,
  ACTIVITY_DIY_PATH,
  JUKE_PATH,
  LIVE_MANAGE_PATH,
  COUPONS_PATH,
  MARKETING_PRODUCT_DETAIL_PATH
} from '@constant'
import { hashHistory } from 'react-router'

class Store {
  goToService = product_id => {
    const linkObj = {
      [PRODUCT_JUKE]: JUKE_PATH,
      [PRODUCT_LIVE]: LIVE_MANAGE_PATH,
      [PRODUCT_COUPONS]: COUPONS_PATH,
      [PRODUCT_REGISTRATION_ACTIVITY]: ACTIVITY_DIY_PATH,
      [PRODUCT_WECHAT_WEAPP]: '',
      [PRODUCT_WATER_MIRROR]: '/localMerchant/marketingCenter/waterMirror',
      [PRODUCT_WEDDING_HALL]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_WEDDING_HALL}`,
      [PRODUCT_INVITATION_CARD]: `${MARKETING_PRODUCT_DETAIL_PATH}/${PRODUCT_INVITATION_CARD}`
    }

    const link = linkObj[String(product_id)]
    link && hashHistory.push(link)
  }
}

export default Store
